$(function(){
   $('body').on('click','.header__icon--menu', function(){
       setTimeout(function (){
   $('.menu-drawer-container').addClass('menu-opening');
         }, 70);
  });
  
  $('.closeIcon').on('click', function(){
    $('.js .menu-drawer').attr('style', 'transform : translate(-99%,-99%) !important;transition:transform 220ms linear !important;');
    setTimeout(function (){
   $('.menu-drawer-container').removeClass('menu-opening');
    $('.menu-drawer-container').removeAttr('open');
	   $('.js .menu-drawer').removeAttr('style');
}, 70);
  }); 
  $(".header__search span").hover(function(){
   $(this).children('.search-text').css("display","block");
    $(this).children('svg').css('transform','scale(1.2,1.2)');
    if($(window).width() > 768){
    $(this).attr('style','width:30rem !important;transition:width 100ms linear !important;border:1px solid #000; border-radius:5px;height:3.5rem;');}
    else{
         $(this).children('.search-text').css("display","none");
    }
  }, function(){
      $(this).children('.search-text').css("display", "none");
        $(this).children('svg').css('transform','scale(1,1)');
      $(this).removeAttr('style');
});
  
//   ================ HEIGHT OF MEGA MENUS Adjustment =======
//   $('.normalItem span').hover(function(){
//   console.log("hover in");
// 	var hei =  $('.differentNavMenu .list-menu--disclosure').height();
//     hei=hei+35;
//   $('.header__submenu .normalItem .Step2').css('min-height',hei);
//   }, function(){
//     console.log("hover out");
// });
// 	console.log(hei);
});
// $('body').on('click','.level-sub', function(){
//   $(this).parent().parent().find('ul').eq(0).toggle();
//   if(  $(this).parent().children('.iconPlus').children().css('display')=='none'){
//     $(this).parent().children('.iconPlus').children().css('display','inline');
//   }else{
//     $(this).parent().children('.iconPlus').children().css('display','none');
//   }
//   $(this).parent().parent().parent().siblings().each(function(){     
//     $(this).children().children('.menu-drawer__menu.list-menu').css('display','none');
//     $(this).children().children('.labelWrapper').children('.iconPlus').children().css('display','inline');
//   });
// });
// mobile navigatin menu
$(document).ready(function(){
  $('.labelWrapper .svgICON1').on('click', function(){
    $(this).parent().parent().children('ul').eq(0).toggle();
    $(this).siblings('.iconPlus').toggle();
    console.log("first level on");
  });
    $('.labelWrapper .svgICON2').on('click', function(){
    $(this).parent().parent().children('ul').eq(0).toggle();
          $(this).siblings('.L2iconPlus').toggle();
      console.log("second level on");
    });
      });


// search model page 
$(document).ready(function(){ 
  $('.explore-boxes').children().each(function(){
  var colValue = $(this).data('color');
//     console.log('wcs');
    $(this).children('.row.requireBefore').children('.overFlow').css('background-color',colValue);
	$(this).children('.row.requireBefore').attr('style','background: linear-gradient(to left, #fff 50% , '+colValue+' 50%) right;');   
});
  $('#top-search-box111').on('click', function(){
  $('#searchModal').css('display','block');
    $('#searchElement').focus();
    $(this).css('display','none');
    $('.close-pop-up').css('display','block');
  });
  
  $('.close-pop-up').on('click', function(){
    $('#searchModal').css('display','none');
    $('#top-search-box111').css('display','inline-block');
    $(this).css('display','none');
  });
});
$(document).keydown(function(e) {
    // ESCAPE key pressed
    if (e.keyCode == 27) {
          $('#searchModal').css('display','none');
		    $('.close-pop-up').css('display','none');
          $('#top-search-box111').css('display','inline-block');
    }
});